import { useNavigate } from "react-router-dom";
import { BarChart3, HeartPulse } from "lucide-react";

export default function AdminChoice() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <p className="text-sm font-bold tracking-wide text-emerald-700 mb-1">Trata Health</p>
        <h1 className="text-3xl font-extrabold text-slate-900">Welcome, Admin</h1>
        <p className="text-slate-500 mt-1 mb-8">Where would you like to go?</p>

        <button
          data-testid="choose-admin-portal"
          onClick={() => navigate("/admin")}
          className="w-full text-left rounded-2xl p-6 mb-5 bg-[#5b2ea6] hover:opacity-95 active:scale-[0.99] transition shadow-lg"
        >
          <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center mb-4">
            <BarChart3 className="text-white" size={28} />
          </div>
          <div className="text-xl font-extrabold text-white">Admin Portal</div>
          <div className="text-sm text-white/80 mt-1">App usage, funnels &amp; performance analytics</div>
        </button>

        <button
          data-testid="choose-patient-app"
          onClick={() => navigate("/home")}
          className="w-full text-left rounded-2xl p-6 bg-white border border-slate-200 hover:border-slate-300 active:scale-[0.99] transition"
        >
          <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mb-4">
            <HeartPulse className="text-emerald-700" size={28} />
          </div>
          <div className="text-xl font-extrabold text-slate-900">Patient App</div>
          <div className="text-sm text-slate-500 mt-1">Use the app as a patient</div>
        </button>
      </div>
    </div>
  );
}
